import Divider, {DividerProps} from '@mui/material/Divider';

import {styled} from '@mui/material/styles';

export const CDivider = styled(Divider)<DividerProps>(
  (/* { theme } */) => ({
  }),
);
